module.exports = __webpack_public_path__ + "static/media/dist.1f9a5047.png";